export const headersExportUsabilty = [
    { v: "Identificación", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Nombre Completo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Cargo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Base", t: "s", s: { font: { sz: 12, bold: true } } }, 
    { v: "Módulo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Último Uso", t: "s", s: { font: { sz: 12, bold: true } } },
];
